<script lang="ts" setup>
  import { type PropType, computed } from 'vue';
  import { useRoute } from '@othercommerce/foundation';
  import type { Country, CustomerShippingAddress } from '@storefront/types';
  import type { Dictionary } from '@othercommerce/domain';
  import { StoreLayout, AccountLayout } from '@storefront/components';

  const open = defineModel('open', { type: Boolean, required: false, default: false });

  const props = defineProps({
    countries: { type: Array as PropType<Country[]>, required: true },
    isMedicalProvider: { type: Boolean, default: false },
    addressType: { type: Array as PropType<Dictionary>, required: true },
    address: { type: Object as PropType<CustomerShippingAddress>, required: true },
    regions: { type: Object as PropType<Dictionary>, required: true },
  });

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  const route = useRoute();

  const action = computed(() =>
    props.address.meta.exists
      ? route('web.account.address.shipping.update', { address: props.address.id })
      : route('web.account.address.shipping.store'),
  );

  const method = computed(() =>
    props.address.meta.exists
      ? 'PATCH'
      : 'POST',
  );
</script>
<template>
  <UiModal medium open visitable>
    <FormController v-slot="{ data, submit, processing }" :action="action" :data="address" :method="method" class="shipping-address-form">
      <header>
        <slot name="header">
          <h2 v-if="data.id" class="shipping-address-form__heading">
            {{ $t('SHOP.ACCOUNT.HEADER.SHIPPING_ADDRESS_EDIT') }}
          </h2>
          <h2 v-else class="shipping-address-form__heading">
            {{ $t('SHOP.ACCOUNT.HEADER.SHIPPING_ADDRESS_CREATE') }}
          </h2>
        </slot>
      </header>
      <SfShippingAddressForm :countries :data :regions />
      <UiButtonGroup end>
        <SfButton :href="$route('web.account.address.shipping.index')">
          {{ $t('SHOP.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :loading="processing" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </UiButtonGroup>
    </FormController>
  </UiModal>

  <RouterView />
</template>
